/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AnimaticValueStateConfig,
  AnimaticValueStateConfig$inboundSchema,
} from "./animaticvaluestateconfig.js";

/**
 * A single value item to display on the shelf.
 */
export type AnimaticValueItem = {
  /**
   * The name of the item
   */
  name: string;
  /**
   * The states to display in the item
   */
  states: Array<AnimaticValueStateConfig>;
};

/** @internal */
export const AnimaticValueItem$inboundSchema: z.ZodType<
  AnimaticValueItem,
  z.ZodTypeDef,
  unknown
> = z.object({
  name: types.string(),
  states: z.array(AnimaticValueStateConfig$inboundSchema),
});

export function animaticValueItemFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticValueItem, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticValueItem$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticValueItem' from JSON`,
  );
}
